import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppContextService, EcaGenericMessageDialogComponent, EcaGenericMessageDialogConfig, WindowService, EcaPillarBoxModule } from '@drc-eca/eca-components-lib';
import { environment } from '../../../environments/environment';
import { UserManagementService } from '../../user/services/user-management.service';
import { DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultFlexDirective } from '@ngbracket/ngx-layout/flex';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [EcaPillarBoxModule, DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultFlexDirective, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatButton, MatProgressSpinner]
})
export class ForgotPasswordComponent implements OnInit {
  private appContextService = inject(AppContextService);
  private userManagementService = inject(UserManagementService);
  private windowService = inject(WindowService);
  private router = inject(Router);
  private dialog = inject(MatDialog);


  form: UntypedFormGroup;
  loginRoute: string = '/login';
  productCode!: string;
  isSaving = false;

  constructor() {
    const fb = inject(UntypedFormBuilder);

    const emailPattern = `^[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+\\/=?^_‘{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$`;

    this.form = fb.group({
      userEmail: ['', Validators.pattern(emailPattern)]
    });
  }

  ngOnInit() {
    this.appContextService.getSelectedProductCode().subscribe(productCode => {
      if (productCode) {
        this.productCode = productCode;
        this.loginRoute = `/login/${productCode}`;
      }
    });
  }

  createLoginLink(e: Event) {
    e.preventDefault();
    if (this.windowService.location !== this.windowService['window'].parent.location && environment.islandBrowserUrl) {
      // Must be coming from the embedded login from Island browser.
      this.windowService.location.href = environment.islandBrowserUrl;
    } else {
      // Else we'll let the click continue to the router
      this.router.navigate([this.loginRoute]);
    }
  }

  onSubmit(frm: UntypedFormGroup, formDirective: FormGroupDirective) {
    const message = 'If you entered a valid email address, we will send you an email with instructions on how to change your password.';
    if (frm.invalid) {
      return;
    }
    this.isSaving = true;
    this.userManagementService.forgotPassword(frm.controls.userEmail.value, this.productCode).subscribe(
      () => {
        this.isSaving = false;
        frm.reset();
        formDirective.resetForm();
        this.openGoodModal(message);
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (err) => {
        this.isSaving = false;
        this.openGoodModal(message);
      }
    );
  }

  openGoodModal(inMessage: string) {
    const data: EcaGenericMessageDialogConfig = {
      title: 'Forgot Your Password?',
      message: `<p>${inMessage}</p>`,
    };
    this.dialog.open(EcaGenericMessageDialogComponent, { data });
  }
}
